import { css, keyframes } from "@emotion/css"
import React from "react"

type Props = {
  children?: React.ReactNode
  disabled?: boolean
  width?: number
  height?: number
}

const Skeleton = ({ children, disabled = false, width, height }: Props) => {
  let styleObj: React.CSSProperties | undefined
  if (width || height) {
    styleObj = { width, height }
  } else if (children === undefined) {
    styleObj = { width: "100%", height: "100%" }
  }

  return (
    <div className={disabled ? undefined : style} style={styleObj}>
      {children}
    </div>
  )
}

export default Skeleton

const animation = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`

const style = css`
  position: relative;
  overflow: hidden;
  background: #d9d9d9;
  > * {
    visibility: hidden;
  }
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    content: "";
    background: #d9d9d9;
  }
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    content: "";
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
    animation: ${animation} 1.2s linear infinite;
  }
`
